import React from "react";
import "swiper/css";
import { styled } from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper";
import { getCurrentUserInfo } from "../../utils/UserAuth";

/* eslint-disable react/prop-types */
const FilterCategory = ({ currentTab, tabList, handleClick }) => {
	const currentAdmin = getCurrentUserInfo();

	const newTabList = () => {
		if (currentAdmin?.role === "Logistics") {
			return tabList.filter((tab) => tab.id !== "awaiting_purchase");
		} else {
			return tabList;
		}
	};
	const FilterItem = ({ item }) => {
		const isActive = currentTab === item.id ? "active" : "";
		return (
			<div
				className={`filterItem ${isActive}`}
				onClick={(e) => {
					e.preventDefault();
					handleClick(item.id);
				}}>
				{item.title}
			</div>
		);
	};

	const getSlidesPerView = (numberOfTabs) => {
		if (numberOfTabs <= 3) return numberOfTabs;
		else if (numberOfTabs <= 6) return numberOfTabs - 1;
		else if (numberOfTabs >= 8) return numberOfTabs - 4;
		else return numberOfTabs - 1;
	};

	return (
		<FilterWrapper>
			<Swiper
				slidesPerView={getSlidesPerView(tabList.length)}
				freeMode={true}
				className='FilterSwiper'
				modules={[FreeMode]}>
				{newTabList()?.map((item) => (
					<SwiperSlide key={item.id} className='swiperItem'>
						<FilterItem item={item} />
					</SwiperSlide>
				))}
			</Swiper>
		</FilterWrapper>
	);
};

export const FilterWrapper = styled.div`
	padding: 20px 0;
	display: flex;
	align-items: center;
	position: relative;
	overflow: hidden;

	.FilterSwiper .swiper-wrapper {
		width: 100vw;

		.swiperItem {
			width: fit-content !important;
			white-space: nowrap;
		}

		.filterItem {
			flex-shrink: 0;
			width: fit-content;
			padding: 8px 23px;
			margin-right: 10px;
			font-weight: 500;
			font-size: 14px;
			color: #888;
			cursor: pointer;

			&.active {
				background: #eff8f9;
				border-radius: 20px;
				color: #333;
			}
		}
	}
`;

export default FilterCategory;
